import { render, staticRenderFns } from "./DentalAppointmentHistoryTable.vue?vue&type=template&id=b6bf7b24&"
import script from "./DentalAppointmentHistoryTable.vue?vue&type=script&lang=js&"
export * from "./DentalAppointmentHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports